export const VILLAGE_SECTIONS = [
  { k: "info", l: "Köy bilgileri" }, { k: "totals", l: "Toplamlar" }, { k: "yearly", l: "Yıllara göre harcamalar" },
  { k: "work", l: "Çalışma kayıtları" }, { k: "materials", l: "Malzemeler" }, { k: "investments", l: "Yatırımlar" },
  { k: "infra", l: "Altyapı projeleri" }, { k: "petitions", l: "Dilekçeler" }, { k: "history", l: "İşlem geçmişi" },
];
const STORE = "khgb_village_report_opts";

export function loadVillageOpts() {
  const all = { usePeriod: false, sections: VILLAGE_SECTIONS.map((s) => s.k) };
  try {
    return { ...all, ...JSON.parse(localStorage.getItem(STORE) || "{}") };
  } catch {
    return all;
  }
}

export function saveVillageOpts(o) {
  localStorage.setItem(STORE, JSON.stringify(o));
}

export const VillageReportOptions = ({ value, onChange, periodText }) => {
  const toggle = (k) => onChange({ ...value, sections: value.sections.includes(k)
    ? value.sections.filter((x) => x !== k) : [...value.sections, k] });
  return (
    <div className="mt-4 p-3 rounded-md bg-slate-50 border border-slate-200 space-y-3" data-testid="village-report-options">
      <label className="flex items-start gap-2 text-sm text-slate-700 cursor-pointer select-none">
        <input type="checkbox" className="h-4 w-4 mt-0.5 accent-emerald-700" checked={value.usePeriod}
               onChange={(e) => onChange({ ...value, usePeriod: e.target.checked })} data-testid="village-report-use-period" />
        <span>Seçili dönemle sınırla <span className="text-xs text-slate-500">({periodText})</span></span>
      </label>
      <div>
        <div className="text-xs font-semibold text-slate-600 mb-1.5">Raporda yer alacak bölümler</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1.5">
          {VILLAGE_SECTIONS.map((s) => (
            <label key={s.k} className="inline-flex items-center gap-1.5 text-sm text-slate-700 cursor-pointer select-none">
              <input type="checkbox" className="h-4 w-4 accent-emerald-700" checked={value.sections.includes(s.k)}
                     onChange={() => toggle(s.k)} data-testid={`village-report-section-${s.k}`} />
              {s.l}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};
